import React, { useMemo } from "react";
import style from "../dashboard.module.scss";
import Icon from "../../../../../components/icon/Icon";
import { useLeaderBoardUserRankingQuery } from "../../../../../store/features/apiSlice";
import leaderboardRewards from "../../../../../assets/dashboardImages/leaderboardRewards.png";

const LeadershipAwardsCard = () => {
  const { data, isLoading, isError } = useLeaderBoardUserRankingQuery();

  const ranking = useMemo(() => data?.ranking, [data]);

  if (isLoading) {
    return <div className={style.card}>Yükleniyor...</div>;
  }

  if (isError || !ranking) {
    return <div className={style.card}>Veriler alınamadı.</div>;
  }

  return (
    <div className={`${style.card} ${style.scrollableCard}`}>
      <h5 className={style.sectionTitle}>
        <img width={"30px"} src={leaderboardRewards} alt="leaderboard rewards" />
        Liderlik ve Ödüller
      </h5>

      <div className={style.itemBox}>
        <span className="fs-1 me-2 p-1">🏆</span>
        <p className="mb-1 fw-bold text-light d-inline">
          Sıralama: <strong>{ranking.general.position} / {ranking.general.total}</strong>
        </p>
      </div>

      <hr className="my-1" />

      <div className={style.itemBox}>
        <span className="fs-1 me-2 p-1">🎖</span>
        <p className="mb-1 fw-bold text-light d-inline">
          Rozetler: <strong>{ranking.badges.earned} / {ranking.badges.total_available}</strong>
        </p>
      </div>

      <hr className="my-1" />

      <div className={style.itemBox}>
        <span className="fs-1 me-2 p-1">📜</span>
        <p className="mb-1 fw-bold text-light d-inline">
          Sertifikalar: <strong>{ranking.certificates.earned} / {ranking.certificates.total_available}</strong>
        </p>
      </div>

      <hr className="my-1" />

      <div className={style.itemBox}>
        <span className="fs-1 me-2 p-1">🏅</span>
        <p className="mb-1 fw-bold text-light d-inline">
          Sınıf Başarı Sırası: <strong>{ranking.classroom.position} / {ranking.classroom.total}</strong>
        </p>
      </div>
    </div>
  );
};

export default React.memo(LeadershipAwardsCard);
